import React, { FC } from 'react'
import { Menu, MenuItems, MenuPopover } from '@reach/menu-button'
import styled from 'styled-components'
import css from '@styled-system/css'
import Stack from '@careguide/stack'
import { ContentBlock, respondTo } from '@careguide/theme'
import MobileMenuButton from './HamburgerMenuButton'
import UpgradeCta from 'components/Header/UpgradeCta'

export type LayoutMobileProps = {
  showUpgradeCta: boolean
}

/**
 * The mobile navigation menu.
 *
 * This component uses `@reach/menu-button` to ensure the navigation is
 * accessible to people using screen reading technology.
 */
export const LayoutMobile: FC<LayoutMobileProps> = ({ children, showUpgradeCta }) => (
  <Menu>
    {({ isExpanded }) => (
      <>
        <MobileOnlyStack align='right' direction='horizontal' gap='4'>
          {showUpgradeCta && <UpgradeCta />}
          <MobileMenuButton isExpanded={isExpanded} />
        </MobileOnlyStack>

        <MobileMenuPopover>
          <ContentBlock maxWidth='300px'>
            <MobileMenuItems>{children}</MobileMenuItems>
          </ContentBlock>
        </MobileMenuPopover>
      </>
    )}
  </Menu>
)

const MobileOnlyStack = styled(Stack)`
  ${respondTo.desktop`
    display: none;
  `}
`

const MobileMenuPopover = styled(MenuPopover)`
  position: fixed !important;
  width: 100%;
  height: calc(100vh - 48px);
  top: 48px !important;
  left: 0 !important;
  overflow: hidden;
  z-index: 1000;

  ${css({
    bg: 'gray.0',
    pt: 10,
    a: {
      fontWeight: 'bold',
    },
  })}

  ${respondTo.desktop`
    display: none;
  `}
`

const MobileMenuItems = styled(MenuItems)`
  outline: none;

  > * + * {
    ${css({
      marginTop: 10,
    })}
  }
`

export default LayoutMobile
